import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'plus-icon-button',
  templateUrl: './plus-icon-button.component.html',
  styleUrls: ['./plus-icon-button.component.scss']
})
export class PlusIconButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
